import { render, staticRenderFns } from "./WarehousesOverview.vue?vue&type=template&id=39648e34&scoped=true&"
import script from "./WarehousesOverview.vue?vue&type=script&lang=js&"
export * from "./WarehousesOverview.vue?vue&type=script&lang=js&"
import style0 from "./WarehousesOverview.vue?vue&type=style&index=0&id=39648e34&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39648e34",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\a\\1\\s\\Locate2u.AppPortal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('39648e34')) {
      api.createRecord('39648e34', component.options)
    } else {
      api.reload('39648e34', component.options)
    }
    module.hot.accept("./WarehousesOverview.vue?vue&type=template&id=39648e34&scoped=true&", function () {
      api.rerender('39648e34', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/Warehouses/WarehousesOverview.vue"
export default component.exports